

<template>

<div>
    <v-row class="ma-1" style="height: 60px;margin-top:  2% !important;">
        <v-col cols="1"></v-col>
        <v-col>
            <v-autocomplete v-model="make" :rules="[rules.required]" :items="makes" dense chips @focus="searchMakes" clearable @change="makeChange" item-color='blue' small-chips label="Make" solo></v-autocomplete>
        </v-col>
        <v-col>
            <v-autocomplete v-model="model" :rules="[rules.required]" :items="models" dense chips @change="modelChange" small-chips label="Model" solo></v-autocomplete>
        </v-col>
        <v-col>
            <v-autocomplete v-model="year" :rules="[rules.required]" :items="years" dense chips small-chips label="Year" solo></v-autocomplete>
        </v-col>
        <v-col>
            <v-btn rounded color="primary" @click="search">
                Search
            </v-btn>
        </v-col>
    </v-row>

    <v-container v-if="items.length > 0">
        <h5>
        Available Keys:
      </h5>
        <v-chip-group column>
            <v-chip class="key" v-bind:key="item.id" v-for="item in items" :color="isInStock(item.totalStock)" outlined @click="onItemClick(item)">
                {{item.key.fcc}} - {{item.totalStock}} in stock
            </v-chip>
        </v-chip-group>
    </v-container>

    <v-dialog v-if="item != null" v-model="details" transition="dialog-bottom-transition" fullscreen>

        <v-card fill-height>
            <v-toolbar dark dense color="primary">
                <v-btn icon dark @click="details = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Item Information</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row>
                <v-col cols="1"></v-col>
                <v-col cols="7">
                    <v-card>
                    <v-card-title>Key Information</v-card-title>
                    <v-divider class="mx-4 ma-1"></v-divider>
                    <v-row class="ma-1" justify="center" align="center">
                        <v-col cols="4">
                            <v-text-field v-model="item.key.oem" readonly dense type="text" label="OEM:" outlined></v-text-field>
                            <v-text-field v-model="item.key.ic" readonly dense type="text" label="IC:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="item.key.fcc" readonly dense type="text" label="FCC:" outlined></v-text-field>
                            <v-text-field v-model="item.key.iSKU" readonly dense type="text" label="Internal Sk:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="3">
                            <img @click="showModal" style="cursor:pointer" :src="item.key.image" height="120" width="120">
                        </v-col>
                    </v-row>
                    <v-row class="ma-1" style="height:50px">
                        <v-col cols="4">
                            <v-text-field v-model="item.key.globalpart" readonly dense type="text" label="Global Part:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="item.key.freq" readonly dense type="text" label="Frequency:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="item.key.threshold" readonly dense type="text" label="Threshold:" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ma-1">
                        <v-col cols="4">
                            <v-text-field v-model="item.key.keyType.type" readonly dense type="text" label="Key Type:" outlined></v-text-field>
                            <v-text-field v-model="item.key.description" readonly dense type="text" label="Description:" outlined></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-if="item.key.transponder" v-model="item.transponder.transponder" readonly dense type="text" label="Transponder:" outlined></v-text-field>
                            <v-text-field v-else readonly dense type="text" label="Transponder:" outlined></v-text-field>
                            <v-text-field v-model="item.key.notes" readonly dense type="text" label="Notes:" outlined></v-text-field>

                        </v-col>
                        <v-col cols="4">
                            <v-card-subtitle class="pa-1">Buttons:</v-card-subtitle>
                            <v-chip color="primary" text-color="white" style="margin-left:2px; margin-top:2px" v-bind:key="button.button" v-for="button in item.key.buttons">
                                {{button.button}}
                            </v-chip>
                        </v-col>
                    </v-row>
                    </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card>
                  <v-card-title>Inventory Information</v-card-title>
                  <v-divider class="mx-4 ma-1"></v-divider>
                  <v-row v-bind:key="loc.id" v-for="loc in inventory.locations" style="min-height:50px">
                    <v-col cols="1"></v-col>
                    <v-col class="text-info">{{loc.location.name}}:</v-col>
                    <v-col v-if="item != null">
                      <b-button size="sm" variant="info">{{loc.amount}} in Stock</b-button>
                    </v-col>
                  </v-row>
                  </v-card>
                </v-col>
            </v-row>




        </v-card>


    </v-dialog>

</div>

</template>

<script>

export default {

    data: () => ({
        item: null,
        makes: [],
        make: '',
        inventory: null,
        models: [],
        model: '',
        years: [],
        year: '',
        vehicle: null,
        items: [],
        details: false,
         rules: {
            required: value => !!value || 'Required.',
            
            }
    }),
    methods: {
        showModal() {
                this.$modal.show('image');
            },
            onItemClick(item) {
                this.item = item;
                this.$overlay.show(this);

                this.$api.getItem(item.key.oem).then((res => {
                    if (res.status == 200){
                        this.inventory = res.data;
                        this.details=true;
                    }
                    this.$overlay.hide();
                })).catch(er => {
                    this.$overlay.hide();
                })

            },
            isInStock(stock) {
                if (stock > 0)
                    return "blue";
                else
                    return "#f5bf42";
            },
            makeChange() {
                this.model = '';
                this.year = '';
                this.vehicle = null;
                this.items = [];
                this.item = null;
                if (this.make != null) {
                    this.$api.getModels(this.make).then((response) => {
                        if (response.status == 200) {
                            this.models = response.data;
                        }
                    })
                }
            },
            modelChange() {
                this.year = '';
                if (this.make != null && this.model != null) {
                    this.$api.getYears(this.make, this.model).then((response) => {
                        if (response.status == 200) {
                            this.years = response.data;
                        }
                    })
                }
            },
            search() {
                if (this.make == '' || this.model == '' || this.year == '') {
                    this.$toasted.error('Selection incomplete').goAway(1200)
                    return;
                }
                if (this.make && this.model && this.year) {
                let replace = (this.vehicle == null);
                this.$overlay.show(this);
                if (this.year != '') {
                    this.$api.searchVehicle(this.make, this.model, this.year).then((response) => {
                        if (response.status == 200) {
                            this.vehicle = response.data;
                            this.getItems();
                        }

                    }).then(error => {
                        this.$overlay.hide();
                    })
                }}
            },
            getItems() {
                this.$api.getItemsByVehicle(this.make, this.model, this.year)
                    .then((res) => {
                        if (res.status == 200) {
                            this.items = res.data;
                        }
                        this.$overlay.hide();
                    }).catch(err => {
                        this.$overlay.hide();
                    })
            },
            searchMakes() {
                this.$api.getMakes().then((response) => {
                    if (response.status == 200)
                        this.makes = response.data;
                })
            }
    }
}

</script>
